import React from "react";
import CreateOrgUi from "./CreateOrgUi";
import { SubmitHandler } from "react-hook-form";

export type CreateOrgCredential = {
  email?: string;
  partnerId?: string;
  fullName?: string;
  address: string;
  cityName?: string;
  pinCode: string;
  stateName?: string;
  orgName: string;
  gstNumber: string;
  tinNumber: string;
  panNumber: string;
};

export type CreateOrgPayload = {
  orgName: string;
  gst: string;
  pan: string;
  partnerId: string | null;
  status: boolean;
  domains: never[];
  tin: string;
  logo: string;
  wallpaper: string;
  orgAddress: string;
  address: {
    countryName: string;
    countryCode: string;
    stateName: string;
    stateCode: string;
    cityName: string;
    lat: string;
    lon: string;
    pincode: string;
    address: string;
  };
  admin: {
    fullName: string;
    email: string;
  };
};

function CreateOrg() {
  // const { isSuccess, isError, isPending, mutate, error, data } =
  // useCreateOrgMutation();

  const onSubmit: SubmitHandler<CreateOrgCredential> = (data) => {
    // const payload: CreateOrgPayload = {
    //   orgName: data.orgName,
    //   gst: data.gstNumber,
    //   pan: data.panNumber,
    //   partnerId: data.partnerId || null,
    //   status: true,
    //   domains: [],
    //   tin: data.tinNumber,
    //   logo: "",
    //   wallpaper: "",
    //   orgAddress: "",
    //   address: {
    //     countryName: "India",
    //     countryCode: "In",
    //     stateName: data.stateName || "",
    //     stateCode: data.stateName || "",
    //     cityName: data.cityName || "",
    //     lat: "",
    //     lon: "",
    //     pincode: data.pinCode,
    //     address: data.address,
    //   },
    //   admin: {
    //     fullName: data.fullName || "",
    //     email: data.email || "",
    //   },
    // };

    // mutate(payload);
  };
  return (
    <div className="h-full w-full flex flex-col gap-5 rounded-md bg-white ">
      <div className=" flex flex-col gap-3 border rounded-md md:p-5 p-3">
        <h3 className="page-heading  ">Create Organization</h3> <hr />
        <CreateOrgUi
          onSubmit={onSubmit}
          // isPending={isPending}
          // selectedState={selectedState}
          // setSelectedState={setSelectedState}
        />
      </div>
    </div>
  );
}

export default CreateOrg;
